export default function ProxyPage() {
  return (
    <ul>
      <li>Proxy: </li>
    </ul>
  );
}
